var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCbWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4867 18.7503C13.4867 20.5347 16.2318 21.983 19.6169 21.983C23.0021 21.983 25.7472 20.5347 25.7472 18.7503M3.67822 12.2847C3.67822 14.0692 6.42336 15.5175 9.80849 15.5175C11.189 15.5175 12.4629 15.277 13.4867 14.871M3.67822 16.8106C3.67822 18.5951 6.42336 20.0434 9.80849 20.0434C11.189 20.0434 12.4617 19.8029 13.4867 19.3968M19.6169 16.8106C16.2318 16.8106 13.4867 15.3623 13.4867 13.5779C13.4867 11.7934 16.2318 10.3451 19.6169 10.3451C23.0021 10.3451 25.7472 11.7934 25.7472 13.5779C25.7472 15.3623 23.0021 16.8106 19.6169 16.8106Z",
    stroke: "white",
    strokeWidth: 1.51096,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67822 7.11206V21.3362C3.67822 23.1207 6.42336 24.569 9.80849 24.569C11.189 24.569 12.4617 24.3284 13.4867 23.9224M13.4867 23.9224V13.5776M13.4867 23.9224C13.4867 25.7069 16.2318 27.1552 19.6169 27.1552C23.0021 27.1552 25.7472 25.7069 25.7472 23.9224V13.5776M15.9388 10.9914V7.11206",
    stroke: "white",
    strokeWidth: 1.51096,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80849 10.3449C6.42336 10.3449 3.67822 8.89664 3.67822 7.11215C3.67822 5.32767 6.42336 3.87939 9.80849 3.87939C13.1936 3.87939 15.9388 5.32767 15.9388 7.11215C15.9388 8.89664 13.1936 10.3449 9.80849 10.3449Z",
    stroke: "white",
    strokeWidth: 1.51096,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbWhite);
export default __webpack_public_path__ + "static/media/cb-white.3d1611f1f7010fd8930d70c9328dc486.svg";
export { ForwardRef as ReactComponent };